export class DebugValueConverter
{
    toView(value)
    {
        return console.debug('Easy template debugging ;)', value);
    }
}